import { useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";

interface DisplayPhotoProps {
  url: string;
  index: number;
  onClick?: () => void;
}

function DisplayPhoto({ url, index, onClick }: DisplayPhotoProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="p-3">
      {!imageLoaded && !imageError && (
        <div
          style={{
            width: "100%",
            height: "250px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ProgressSpinner style={{ width: "30px", height: "30px" }} strokeWidth="4" />
        </div>
      )}

      {imageError && (
        <div
          style={{
            width: "250px",
            height: "250px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "8px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <i className="pi pi-image" style={{ fontSize: "2rem", color: "#6c757d" }}></i>
            <p>Image failed to load</p>
          </div>
        </div>
      )}

      {/* eslint-disable-next-line jsx-a11y/img-redundant-alt -- valid alt description */}
      <img
        src={url}
        alt={`DSTI progress photo ${index + 1}`}
        style={{
          width: "100%",
          height: "250px",
          objectFit: "cover",
          cursor: "pointer",
          borderRadius: "8px",
          display: imageLoaded && !imageError ? "block" : "none",
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
        onLoad={() => setImageLoaded(true)}
        onError={() => {
          setImageError(true);
          setImageLoaded(false);
        }}
      />
    </div>
  );
}

export default DisplayPhoto;
